import Vue from 'vue'
import Vuex from 'vuex'
import report from './modules/report'
import * as getters from './getter'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    report,
  },
  state: {
  },
  mutations: {
  },
  userInfo: {},
  isLogin: false
})

export default store
